import React from 'react';
import { useCopilotContext } from './CopilotContext';
import { CopilotChat } from './CopilotChat';
import './CopilotPanel.scss';

export default function CopilotPanel() {
  const { open, closePanel } = useCopilotContext();

  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="copilot-backdrop"
        onClick={closePanel}
      />

      {/* Panel */}
      <div className={`copilot-panel ${open ? 'open' : ''}`}>
        <CopilotChat onClose={closePanel} />
      </div>
    </>
  );
}
